import React from 'react';
import * as e from '../elements';

export default {
  name: 'Cover w/ Signup Form',
  description: 'Product shot with a signup form',
  thumb: 'coming-soon',
  tags: ['Cover'],
  jsx: (
    <e.PBlock
      height="content"
      pad="md"
    >
      <div className="row align-items-center">
        <div className="col-12 order-2 text-center col-md-6 order-md-1 py-3">
          <e.PImage src="https://lh3.googleusercontent.com/tc3fcQnBaNrVqHJFfJE51i5wG_xprEHiW7i7iyaw5UfhmPZFeSK44Ng-eaYu3Jl0RvfpG8xip5wN72-mIdCwgw" alt="" renderSize="720" />
        </div>
        <div className="col-12 order-1 col-md-6 order-md-2">
          <div className="row">
            <div className="col-12 text-left">
              <e.PText key="1" text="Provide us with your contact details and we will get back to you." size="text-md" className="mb-3" />
            </div>
          </div>
          <form>
            <div className="form-group row">
              <label className="col-sm-12 col-form-label">Name</label>
              <div className="col-sm-12">
                <input
                  type="text" className="form-control"
                  value="first name last name"
                />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-sm-12 col-form-label">Email</label>
              <div className="col-sm-12">
                <input
                  type="text"
                  className="form-control"
                />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-sm-12 col-form-label">Message</label>
              <div className="col-sm-12">
                <textarea
                  type="text" className="form-control"
                  rows="3"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <e.PButton text="submit" size="xl" color="primary" />
              </div>
            </div>
          </form>
        </div>
      </div>
    </e.PBlock>
  ),
};



// WEBPACK FOOTER //
// ./scripts/components/editor/blocks/CoverImageSignup.jsx